import { buildASTSchema } from 'graphql'; // ES6
import { loader } from 'graphql.macro';
const schema = loader('./schema.graphql');

export const SCHEMA=buildASTSchema(schema)

